
export async function callAPI<T1, T2>(
  endpoint: string,
  body: T1, 
): Promise<T2> {
  console.log(JSON.stringify(body))
  const res = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body)
  })

  if (res.status === 409) {
    throw new Error("MODEL_BUSY")
  }

  if (!res.ok) {
    throw new Error(`API Error: ${res.status}`)
  }

  return res.json() as Promise<T2>
}